import { render, staticRenderFns } from "./BotDetectHistory.vue?vue&type=template&id=6f5fff96&scoped=true"
import script from "./BotDetectHistory.vue?vue&type=script&lang=js"
export * from "./BotDetectHistory.vue?vue&type=script&lang=js"
import style0 from "./BotDetectHistory.vue?vue&type=style&index=0&id=6f5fff96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5fff96",
  null
  
)

export default component.exports